var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _path8, _g4, _path9, _path0, _path1, _g5, _path10, _path11, _path12, _g6, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourIconSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 96,
    viewBox: "0 0 122 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_9430)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4808 18.9465L89.9135 19.1906L89.7911 21.4124L85.3585 21.1683L85.4808 18.9465Z",
    fill: "#737373"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 33,
    width: 74,
    height: 58
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.965 33.0357L95.8517 36.9392L92.8866 90.7825L21.9999 86.879L24.965 33.0357Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_9430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.943 33.4358L22.4967 77.859C22.2266 82.7636 25.9847 86.9627 30.8921 87.2329L84.2 90.1684C89.1046 90.4385 93.3038 86.6777 93.5739 81.773L96.0201 37.3498L24.943 33.4358Z",
    fill: "#662D91"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 15,
    width: 73,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9377 15.3713L96.8244 19.2749L95.6961 39.7656L24.8094 35.862L25.9377 15.3713Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_9430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.114 19.0914L34.8062 16.1559C29.8988 15.8856 25.7025 19.6439 25.4323 24.5513L24.8206 35.6577L95.8978 39.5718L96.5094 28.4653C96.7796 23.5579 93.0186 19.3615 88.114 19.0914Z",
    fill: "#E3E3E3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5261 27.0102C38.9666 26.9244 37.7868 25.3755 37.8874 23.5483C37.988 21.7212 39.3308 20.3113 40.8902 20.3971C42.4497 20.483 43.6296 22.0319 43.5289 23.859C43.4285 25.6834 42.0855 27.0961 40.5261 27.0102ZM53.8544 27.7442C52.295 27.6583 51.1123 26.1093 51.213 24.2822C51.3136 22.455 52.6591 21.0452 54.2186 21.1311C55.7753 21.2168 56.9579 22.7658 56.8573 24.593C56.7568 26.4174 55.4111 27.8299 53.8544 27.7442ZM67.18 28.478C65.6206 28.3921 64.4379 26.8431 64.5385 25.016C64.6392 23.1888 65.9847 21.779 67.5442 21.8649C69.1008 21.9506 70.2862 23.4998 70.1856 25.3269C70.0824 27.1512 68.7367 28.5637 67.18 28.478ZM80.5083 29.212C78.9489 29.1261 77.7663 27.5771 77.8669 25.7499C77.9675 23.9228 79.3131 22.513 80.8725 22.5989C82.4292 22.6846 83.6118 24.2336 83.5112 26.0607C83.4107 27.8851 82.065 29.2977 80.5083 29.212Z",
    fill: "#292F33"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 7,
    width: 58,
    height: 22
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6761 7.45583L90.4957 10.5297L89.4899 28.793L33.6704 25.7192L34.6761 7.45583Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_9430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6168 10.2757C79.7794 10.1195 77.2248 11.7672 75.7269 14.2843C74.5197 11.6736 72.1534 9.69956 69.2912 9.54194C66.4539 9.3857 63.8992 11.0334 62.3985 13.5503C61.1941 10.9398 58.8278 8.96575 55.9629 8.80798C53.1283 8.65189 50.5736 10.2996 49.073 12.8165C47.8657 10.2059 45.4995 8.23179 42.6373 8.07417C38.3399 7.83753 34.6397 11.6868 34.3723 16.5417C34.1456 20.6597 36.2812 24.1576 39.6 25.5751C41.2499 26.2805 42.3732 24.7339 42.2978 23.4397C42.235 22.3676 41.564 21.633 40.8048 21.0901C39.7632 20.3489 38.7064 18.7266 38.8127 16.7973C38.9476 14.3464 40.5593 12.2259 42.4003 12.3273C44.2413 12.4287 45.621 14.5201 45.4987 16.7419L47.7564 16.8662C47.7405 17.0038 47.7057 17.1347 47.6981 17.2727C47.4713 21.3908 49.6069 24.8886 52.9228 26.3087C54.5756 27.0115 55.6962 25.4648 55.6235 24.1707C55.5606 23.1014 54.8895 22.3668 54.1277 21.8238C53.0888 21.0827 52.032 19.4604 52.1382 17.5311C52.2732 15.0802 53.8849 12.9597 55.7259 13.0611C57.5668 13.1625 58.9492 15.2568 58.8269 17.4786L61.0846 17.603C61.0715 17.7407 61.034 17.8687 61.0262 18.0095C60.7995 22.1275 62.9351 25.6253 66.2512 27.0427C67.9038 27.7483 69.0244 26.2015 68.9517 24.9074C68.8889 23.8354 68.2179 23.1008 67.4588 22.5579C66.4171 21.8167 65.3602 20.1971 65.4664 18.2678C65.6015 15.8141 67.2131 13.6964 69.0541 13.7978C70.895 13.8992 72.2776 15.9907 72.1552 18.2126L74.4102 18.3368C74.3971 18.4745 74.3623 18.6027 74.3546 18.7434C74.1278 22.8614 76.2607 26.3591 79.5795 27.7766C81.2322 28.4822 82.3527 26.9355 82.28 25.6414C82.2145 24.5692 81.5462 23.8347 80.7843 23.2917C79.7455 22.5507 78.6858 20.9309 78.792 19.0016C78.9271 16.5479 80.5387 14.4302 82.3797 14.5316C84.2206 14.633 85.6032 16.7245 85.4808 18.9464L89.9135 19.1905C90.1139 14.7471 86.8811 10.5106 82.6168 10.2757Z",
    fill: "#737373"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5671 41.1996L53.4517 41.6888L52.9624 50.5735L44.0778 50.0842L44.5671 41.1996ZM55.6736 41.8112L64.5554 42.3003L64.0662 51.1849L55.1843 50.6958L55.6736 41.8112ZM66.7773 42.4227L75.6619 42.9119L75.1727 51.7965L66.288 51.3073L66.7773 42.4227ZM77.8838 43.0343L86.7684 43.5235L86.2792 52.4082L77.3945 51.9189L77.8838 43.0343ZM32.849 51.6945L41.7336 52.1837L41.2444 61.0684L32.3597 60.5791L32.849 51.6945ZM43.9555 52.3061L52.8401 52.7953L52.3508 61.68L43.4662 61.1907L43.9555 52.3061ZM55.0619 52.9177L63.9438 53.4068L63.4546 62.2914L54.5727 61.8023L55.0619 52.9177ZM66.1657 53.5291L75.0503 54.0184L74.5611 62.903L65.6764 62.4138L66.1657 53.5291ZM77.2722 54.1408L86.1568 54.63L85.6676 63.5146L76.7829 63.0254L77.2722 54.1408ZM32.2375 62.7982L41.1222 63.2875L40.6329 72.1721L31.7483 71.6828L32.2375 62.7982ZM43.344 63.4098L52.2286 63.8991L51.7394 72.7837L42.8547 72.2945L43.344 63.4098ZM54.4505 64.0214L63.3324 64.5105L62.8431 73.3952L53.9612 72.9061L54.4505 64.0214ZM65.5542 64.6329L74.4389 65.1221L73.9496 74.0068L65.065 73.5175L65.5542 64.6329ZM76.6607 65.2445L85.5454 65.7337L85.0561 74.6184L76.1715 74.1291L76.6607 65.2445ZM31.6259 73.9047L40.5105 74.394L40.0213 83.2786L31.1366 82.7893L31.6259 73.9047ZM42.7324 74.5163L51.617 75.0056L51.1278 83.8902L42.2431 83.4009L42.7324 74.5163ZM53.8389 75.1279L62.7208 75.617L62.2315 84.5017L53.3496 84.0126L53.8389 75.1279Z",
    fill: "#9958CA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 70,
    width: 5,
    height: 5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3715 70.8054L102.088 70.6307L102.262 74.346L98.546 74.5206L98.3715 70.8054Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_9430)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 70,
    width: 5,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.23 70.718C99.2035 70.7663 98.4105 71.6363 98.4588 72.6635C98.507 73.6896 99.3781 74.4815 100.404 74.4333C101.43 74.3851 102.223 73.515 102.175 72.4889C102.127 71.4617 101.256 70.6698 100.23 70.718Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_9430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3715 70.8054L102.088 70.6307L102.262 74.346L98.546 74.5206L98.3715 70.8054Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 72,
    width: 9,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.002 72.0439L3.56934 72.3932L3.89532 79.3303L11.328 78.9811L11.002 72.0439Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_9430)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 72,
    width: 8,
    height: 8
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8186 72.4086L10.5273 72.0934L10.8425 78.8002L4.13376 79.1154L3.8186 72.4086Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_9430)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 72,
    width: 8,
    height: 7
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17297 72.251C5.32062 72.338 3.88909 73.9087 3.97623 75.763C4.06327 77.6153 5.63577 79.0448 7.48813 78.9578C9.34048 78.8707 10.772 77.3001 10.685 75.4477C10.5978 73.5934 9.02533 72.1639 7.17297 72.251Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_9430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.81934 72.4084L10.5281 72.0931L10.8432 78.8L4.13449 79.1152L3.81934 72.4084Z",
    fill: "#D0BEDD"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 61,
    width: 6,
    height: 6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3622 61.7827L10.531 62.0097L10.7429 66.5189L15.5741 66.2918L15.3622 61.7827Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_9430)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 61,
    width: 6,
    height: 6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.693 62.0196L15.0537 61.8147L15.2585 66.1741L10.8978 66.379L10.693 62.0196Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_9430)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_9430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 61,
    width: 6,
    height: 6
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8733 61.9169C11.6693 61.9735 10.7388 62.9944 10.7954 64.1997C10.852 65.4038 11.8742 66.3329 13.0782 66.2763C14.2822 66.2198 15.2127 65.1988 15.1561 63.9948C15.0995 62.7895 14.0774 61.8603 12.8733 61.9169Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_9430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6929 62.0198L15.0536 61.8148L15.2584 66.1743L10.8977 66.3792L10.6929 62.0198Z",
    fill: "#D0BEDD"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.109 74.8831C106.022 73.0311 107.454 71.4591 109.306 71.3721C111.158 71.2851 112.731 72.7159 112.818 74.5679C112.905 76.4199 111.473 77.9919 109.621 78.0789C107.769 78.1659 106.197 76.7352 106.109 74.8831Z",
    fill: "#D0BEDD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86009 26.2684C6.77306 24.4163 8.20485 22.8444 10.0569 22.7573C11.9089 22.6703 13.4818 24.1011 13.5688 25.9531C13.6559 27.8052 12.2241 29.3771 10.372 29.4641C8.52001 29.5512 6.94712 28.1204 6.86009 26.2684Z",
    fill: "#D0BEDD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.903 30.901C109.85 29.7721 110.722 28.814 111.851 28.761C112.98 28.7079 113.938 29.58 113.991 30.7089C114.044 31.8377 113.172 32.7959 112.043 32.8489C110.914 32.902 109.956 32.0298 109.903 30.901Z",
    fill: "#D0BEDD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.564 15.6091C109.477 13.757 110.908 12.1851 112.76 12.098C114.612 12.011 116.185 13.4418 116.272 15.2938C116.359 17.1459 114.928 18.7178 113.076 18.8048C111.223 18.8919 109.651 17.4611 109.564 15.6091Z",
    fill: "#D0BEDD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.51 25.5053C108.36 26.1649 108.521 27.3827 107.868 28.2251C107.214 29.0676 105.994 29.2164 105.144 28.5568C105.03 28.4683 104.928 28.3698 104.839 28.264L96.5594 35.13C96.5594 35.13 90.4138 28.4604 85.7955 24.9007C81.2801 21.4203 73.4166 17.1841 73.4166 17.1841L78.0048 7.45533C77.8803 7.39554 77.7596 7.32204 77.6455 7.23355C76.7949 6.57398 76.6352 5.35516 77.2885 4.51269C77.9418 3.67022 79.1612 3.5225 80.0117 4.18207C80.8634 4.84246 81.0228 6.05941 80.3696 6.90188C80.0854 7.26831 79.6966 7.50346 79.275 7.59775C80.3131 11.2229 82.2315 13.9877 84.8656 15.1576C88.2619 16.6646 92.1003 15.1926 95.3049 11.6796C94.9084 11.0127 94.9325 10.1504 95.432 9.50628C96.0853 8.66381 97.3055 8.51505 98.156 9.17462C99.0076 9.835 99.1674 11.0538 98.5141 11.8963C98.0146 12.5404 97.1854 12.7784 96.4408 12.5604C93.8363 16.5388 93.3664 20.6228 95.6715 23.537C97.4604 25.7968 100.616 26.9665 104.385 27.0693C104.372 26.6374 104.503 26.2024 104.787 25.836C105.44 24.9935 106.658 24.8449 107.51 25.5053Z",
    fill: "#FFCA55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_9430",
    x: 0.972412,
    y: 0.76989,
    width: 120.304,
    height: 95.0126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.176471 0 0 0 0 0.568627 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_9430"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_9430",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIconSix);
export default __webpack_public_path__ + "static/media/tour_icon_six.bbe00196e68b395692b50b4e1e7eb436.svg";
export { ForwardRef as ReactComponent };